/* Klaviyo Popup Override — Apo.Ge
   Restructures the Klaviyo popup DOM for brand styling.
   Companion: klaviyo-popup-override.css */

(function () {

  function findPopupForm() {
    var dialogs = document.querySelectorAll('[role="dialog"]');
    for (var d = 0; d < dialogs.length; d++) {
      var form = dialogs[d].querySelector('.klaviyo-form');
      if (form) return form;
    }
    return null;
  }

  function initPopup() {
    var popup = findPopupForm();
    if (!popup) return false;
    if (popup.dataset.apogeInitialized === 'true') return true;

    var container = popup.querySelector(':scope > div > div:first-child');
    if (!container) return false;

    var isMobile = window.innerWidth < 750;

    // 1. Wrap all rows in inner card
    if (!container.querySelector('.apoge-inner-card')) {
      var innerCard = document.createElement('div');
      innerCard.className = 'apoge-inner-card';
      while (container.firstChild) {
        innerCard.appendChild(container.firstChild);
      }
      container.appendChild(innerCard);
    }

    var inner = container.querySelector('.apoge-inner-card');
    if (!inner) return false;

    // 2. Hide empty spacer rows
    var rows = inner.querySelectorAll('[data-testid="form-row"]');
    for (var i = 0; i < rows.length; i++) {
      if (rows[i].parentNode !== inner) continue;
      var text = rows[i].textContent.trim();
      if (text === '' || text === '​') {
        rows[i].style.display = 'none';
      }
    }

    // 3. Outer container sizing
    if (isMobile) {
      container.style.cssText = 'display:flex; flex-direction:column; width:100%; max-width:100%; min-width:0; margin:0; padding:0; justify-content:center; box-sizing:border-box; background-image:none; background-color:transparent; border-radius:0; box-shadow:none; overflow:visible;';
      popup.style.padding = '0';
    } else {
      container.style.cssText = 'display:flex; flex-direction:column; width:540px; max-width:540px; min-width:540px; margin:0 auto; padding:40px; justify-content:center; box-sizing:border-box;';
    }

    // 4. Heading — DM Serif Display
    // Find heading by content rather than index — look for the richtext with the most text
    var allRichtext = popup.querySelectorAll('.klaviyo-form-richtext');
    var headingRt = null;
    for (var r = 0; r < allRichtext.length; r++) {
      if (allRichtext[r].textContent.trim().length > 5) {
        headingRt = allRichtext[r];
        break;
      }
    }
    if (headingRt) {
      var ps = headingRt.querySelectorAll('p');
      if (ps[0]) {
        ps[0].style.fontFamily = '"DM Serif Display", serif';
        ps[0].style.fontSize = isMobile ? '32px' : '40px';
        ps[0].style.fontWeight = '400';
        ps[0].style.letterSpacing = '0.6px';
        ps[0].style.lineHeight = '1.3';
        ps[0].style.color = 'rgb(79, 82, 31)';
      }
      var headingSpan = ps[0] ? ps[0].querySelector('span') : null;
      if (headingSpan) {
        headingSpan.style.fontFamily = '"DM Serif Display", serif';
        headingSpan.style.fontSize = isMobile ? '32px' : '40px';
        headingSpan.style.fontWeight = '400';
        headingSpan.style.color = 'rgb(79, 82, 31)';
      }
      var strong = headingRt.querySelector('strong');
      if (strong) strong.style.fontWeight = '400';
      if (ps[1]) {
        ps[1].style.textAlign = 'center';
        ps[1].style.marginTop = '12px';
      }
    }

    // 5. Button — compact 44px
    var buttons = popup.querySelectorAll('.klaviyo-form-button');
    for (var b = 0; b < buttons.length; b++) {
      if (buttons[b].textContent.indexOf('GET 10%') !== -1) {
        buttons[b].style.cssText += '; height:44px !important; min-height:0 !important; padding:0 24px !important; font-size:13px !important; max-height:44px !important;';
      }
    }

    // 6. Squash button row wrapper
    var children = inner.children;
    for (var c = 0; c < children.length; c++) {
      if (children[c].style.display === 'none') continue;
      var t = children[c].textContent;
      if (t.indexOf('GET 10% OFF') !== -1 && t.indexOf('No thanks') === -1) {
        children[c].style.cssText += '; height:auto !important; min-height:0 !important; padding:0 !important;';
        var comp = children[c].querySelector('[data-testid="form-component"]');
        if (comp) comp.style.cssText += '; height:auto !important; min-height:0 !important; padding:0 !important;';
      }
    }

    // 7. Even spacing between visible rows
    var visible = [];
    for (var v = 0; v < children.length; v++) {
      if (children[v].style.display !== 'none' && children[v].offsetHeight > 0) {
        visible.push(children[v]);
      }
    }
    for (var s = 0; s < visible.length; s++) {
      visible[s].style.marginTop = '0';
      visible[s].style.marginBottom = (s < visible.length - 1) ? '16px' : '0';
    }

    // 8. Checkbox row spacing
    var fieldset = popup.querySelector('.klaviyo-checkboxes fieldset');
    if (fieldset) {
      var fieldChildren = fieldset.children;
      for (var f = 0; f < fieldChildren.length; f++) {
        fieldChildren[f].style.marginBottom = '8px';
        fieldChildren[f].style.paddingTop = '4px';
        fieldChildren[f].style.paddingBottom = '4px';
      }
    }
    var labels = popup.querySelectorAll('.klaviyo-checkboxes label');
    for (var l = 0; l < labels.length; l++) {
      labels[l].style.paddingTop = '6px';
      labels[l].style.paddingBottom = '6px';
      labels[l].style.display = 'flex';
      labels[l].style.alignItems = 'center';
    }

    // 9. Close button — fixed top-right
    var closeBtn = popup.closest('[role="dialog"]');
    closeBtn = closeBtn ? closeBtn.querySelector('.klaviyo-close-form') : document.querySelector('.klaviyo-close-form');
    if (closeBtn) {
      closeBtn.style.position = 'fixed';
      closeBtn.style.top = '20px';
      closeBtn.style.right = '20px';
      closeBtn.style.zIndex = '100000';
      closeBtn.style.marginRight = '0';
      closeBtn.style.marginTop = '0';
      closeBtn.style.backgroundColor = 'transparent';
      closeBtn.style.width = '44px';
      closeBtn.style.height = '44px';
      closeBtn.style.display = 'flex';
      closeBtn.style.alignItems = 'center';
      closeBtn.style.justifyContent = 'center';

      var svg = closeBtn.querySelector('svg');
      if (svg) {
        svg.setAttribute('width', '44');
        svg.setAttribute('height', '44');
      }

      var path = closeBtn.querySelector('path');
      if (path) {
        var strokeColor = isMobile ? '#FFF8EF' : '#4F5127';
        path.setAttribute('stroke', strokeColor);
        path.setAttribute('stroke-width', '1.5');
        path.setAttribute('fill', 'none');
        path.style.stroke = strokeColor;
      }

      var circle = closeBtn.querySelector('circle');
      if (circle) {
        circle.setAttribute('stroke', 'rgba(0,0,0,0)');
        circle.setAttribute('fill', 'rgba(0,0,0,0)');
      }
    }

    // 10. Hide all SVG checkboxes
    hideSVGs();

    // 11. Checkbox click handler
    var checkboxArea = popup.querySelector('.klaviyo-checkboxes');
    if (checkboxArea && !checkboxArea.dataset.apogeHandled) {
      checkboxArea.dataset.apogeHandled = 'true';
      checkboxArea.addEventListener('click', function () {
        setTimeout(function () {
          updateDots();
          hideSVGs();
        }, 50);
        setTimeout(function () {
          updateDots();
          hideSVGs();
        }, 150);
      });
    }

    // 12. Remove text highlight backgrounds
    var bgSpans = popup.querySelectorAll('.klaviyo-form-richtext span[data-color]');
    for (var bg = 0; bg < bgSpans.length; bg++) {
      bgSpans[bg].style.backgroundColor = 'transparent';
    }

    // 13. Make overlay transparent now that inner card is built
    var dialog = popup.closest('[role="dialog"]');
    if (dialog) dialog.style.backgroundColor = 'transparent';

    // 14. Disconnect observer — job done
    if (observer) observer.disconnect();

    popup.dataset.apogeInitialized = 'true';
    return true;
  }

  function hideSVGs() {
    var svgs = document.querySelectorAll('.klaviyo-checkboxes label svg');
    for (var i = 0; i < svgs.length; i++) {
      svgs[i].style.cssText = 'display:none !important; width:0; height:0; position:absolute;';
    }
  }

  function updateDots() {
    var labels = document.querySelectorAll('.klaviyo-checkboxes label');
    for (var i = 0; i < labels.length; i++) {
      var isChecked = false;
      var inputId = labels[i].getAttribute('for');
      if (inputId) {
        var input = document.getElementById(inputId);
        if (input && input.checked) isChecked = true;
      }
      if (isChecked) {
        labels[i].classList.add('apoge-checked');
      } else {
        labels[i].classList.remove('apoge-checked');
      }
    }
  }

  // Watch for popup to appear
  var observer = new MutationObserver(function (mutations) {
    for (var m = 0; m < mutations.length; m++) {
      if (mutations[m].addedNodes.length) {
        var popup = findPopupForm();
        if (popup && popup.dataset.apogeInitialized !== 'true') {
          tryInit(0);
          break;
        }
      }
    }
  });

  function tryInit(attempt) {
    if (attempt > 5) return;
    var success = initPopup();
    if (!success) {
      setTimeout(function () { tryInit(attempt + 1); }, 300);
    }
  }

  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (findPopupForm()) {
    tryInit(0);
  }
})();
